import React from 'react';
import { Formik } from 'formik';
import HolderForm from './HolderForm';
import { validationAddingHolder } from '../../utils/validations';
import { connect } from 'react-redux';
import { addHolderFirm } from '../../store/actions/UserAction';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import './addHolders.scss';


var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

function AddHolders(props) {
  const {
    uid,
    nElem,
    evento,
    allHolders,
    addHolderFirm,
    handleSnack,
    trophie,
    alreadyRewarded,
    handleRewarded,
    handleTrophieModalOpen,
    showLoading,
    hideLoading,
  } = props;

  const isObjectFull = (array, values) => {
    if (array === values.laboralHolder) {
      if (array.slice(-1).pop().actualCompanyPosition === false) {
        const allValues = Object.values(array.slice(-1).pop())
        const filteredValues = allValues.filter(elem => elem !== false)
        const evaluation = filteredValues.every(elem => {
          if (elem !== '') {
            return true
          }
          return false
        })
        return evaluation;
      } else {
        const allValues = Object.values(array.slice(-1).pop())
        const slicedValues = allValues.slice(0, 5)
        const evaluation = slicedValues.every(elem => {
          if (elem !== '') {
            return true
          }
          return false
        })
        return evaluation;
      }
    } else {
      const allValues = Object.values(array.slice(-1).pop())
      const evaluation = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
      return evaluation;
    }
  }

  const handleSubmit = async (
    values,
    { setSubmitting, setFieldError, resetForm, setFieldValue }
  ) => {
    setSubmitting(false);
    showLoading()

    const arrayValues = Object.values(values)
    let boolValues = arrayValues.every(elem => elem)

    const sliced = arrayValues.slice(9)
    sliced.some(elem => {
      if (isObjectFull(elem, values) === false) {
        boolValues = false
      }
    })

    if (allHolders !== undefined && allHolders !== '') {
      const realValues = allHolders.every(item => {
        const values = Object.values(item)
        const bool = values.every(elem => elem)
        return bool
      })
      if (realValues === false && realValues !== undefined) {
        boolValues = realValues
      }
    }

    if (boolValues === false) {
      handleRewarded(false)
    }

    addHolderFirm(
      uid,
      values,
      allHolders ? allHolders : [],
      boolValues,
    ).then(res => {
      hideLoading();
      resetTab();
      resetForm();
      if (!alreadyRewarded) {
        handleTrophieModalOpen(trophie)
      }
      setTimeout(() => {
        handleSnack();
      }, 0)
    })
  };

  const formValues = {
    imgProfileHolder: '',
    gender: 'male',
    email: '',
    nameHolder: '',
    firstLastname: '',
    secondLastName: '',
    gradeStudy: '',
    cedula: '',
    specialties: [],
    holderLanguages: [],
    educationHolder: [
      {
        nameUniversity: '',
        receivedGradeStudy: '',
        discipline: '',
        firstYear: '',
        lastYear: '',
      }
    ],
    courses: [
      {
        name: '',
        place: '',
        firstYear: '',
        lastYear: '',
      }
    ],
    certifications: [
      {
        name: '',
        place: '',
        year: '',
        myImageCert: '',
      }
    ],
    awards: [
      {
        name: '',
        place: '',
        year: '',
        myImageAward: '',
      }
    ],
    publications: [
      {
        title: '',
        url: '',
        year: '',
      }
    ],
    laboralHolder: [
      {
        companyPosition: '',
        nameCompany: '',
        actualCompanyPosition: false,
        firstMonth: '',
        firstLaboralYear: '',
        lastMonth: '',
        lastLaboralYear: '',
      }
    ],
  };

  const resetTab = () => {
    scroller.scrollTo('myScroll_Holder', { smooth: true, offset: -64 });
    evento(false);
  };

  return (
    <>
      <div className="addHolders">
        <Formik
          initialValues={formValues}
          validationSchema={validationAddingHolder}
          onSubmit={handleSubmit}
          render={props => (
            <HolderForm
              evento={resetTab}
              nElem={nElem}
              {...props}
              uid={uid}
            />
          )}
        />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  trophie: state.authClient.awardPerfil.holder,
});

const mapDispatchToProps = dispatch => ({
  addHolderFirm: (uid, values, fireBaseUrl, allHolders, boolValues) =>
    dispatch(addHolderFirm(uid, values, fireBaseUrl, allHolders, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHolders);
